export default __webpack_public_path__ + "static/media/voucherGTS3.ffdfeb73.jpg";